import React, { useEffect, useState } from "react";
import MappingTopBox from "./CreatorTools/MappingTool/components/MappingTopBox";
import GeneralRoomCard from "./components/GeneralRoomCard";
import EstimateTypeSelector from "../components/ui/utils/EstimateTypeSelector";
import { EstimateType } from "./CreatorTools/MappingTool/utils/EstimateType";
import { useOrganizationSelect } from "../hooks/useOrganizationSelect";
import OrganizationSelector from "../components/ui/utils/OrganizationSelector";

const GeneralPage: React.FC = () => {
	const { organizations, selectedOrganization, setSelectedOrganization } = useOrganizationSelect();

	const [selectedEstimateType, setSelectedEstimateType] = useState<EstimateType>(EstimateType.RECONSTRUCTION);

	return (
		<div className="min-h-screen bg-gray-50">
			<MappingTopBox />
			<div className="ml-8 mt-8">
				<div className="mt-8 mb-8">
					<h1 className="text-3xl font-bold text-gray-800 mb-6">General Room Properties</h1>
					<p className="text-gray-600 mb-6">
						* This page is used to configure the line items that show up in the General Room for a customer and scope.
						<br />* If line items are not added to any customer or scope, that combination will use the "Default" for that scope.
					</p>
					<div className="grid grid-cols-2 gap-8 mb-8">
						<OrganizationSelector
							organizations={organizations ?? []}
							selectedOrganization={selectedOrganization}
							onSelect={setSelectedOrganization}
						/>

						<EstimateTypeSelector value={selectedEstimateType} onChange={setSelectedEstimateType} />
					</div>
				</div>

				<div className="space-y-8">
					<GeneralRoomCard estimateType={selectedEstimateType} organizationId={selectedOrganization.organizationId} />
				</div>
			</div>
		</div>
	);
};

export default GeneralPage;
